module.exports = __webpack_public_path__ + "media/birthday_tier_2-5f38457453f240b464dc78cd975fdf15.mp3";